import { ChatCircle, Compass, Gear, Globe, Heart, SignOut, Sparkle } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PassportLogo } from "@/components/Reveal";
import NotificationsBell from "@/components/NotificationsBell";
import PassportUserSearch from "@/components/PassportUserSearch";

function HeaderIconLink({ to, title, children, testId, className = "" }) {
    return (
        <Link to={to} title={title} aria-label={title} className={`w-10 h-10 rounded-full glass grid place-items-center ${className}`} data-testid={testId}>
            {children}
        </Link>
    );
}

export default function PassportAppHeader({ homeHref = "/", subtitle = "Passport", maxWidthClass = "max-w-[1400px]" }) {
    const { user, signout } = useAuth() || {};

    return (
        <header className="sticky top-0 z-40 glass border-b" style={{ borderColor: "rgba(255,255,255,0.06)", backdropFilter: "blur(18px)" }}>
            <div className={`${maxWidthClass} mx-auto px-6 md:px-10 py-4 grid gap-3 lg:grid-cols-[auto_minmax(280px,420px)_auto] lg:items-center`}>
                <Link to={homeHref} className="flex items-center gap-3 min-w-0" data-testid="passport-app-header-home-link">
                    <PassportLogo size={34} />
                    <div className="hidden sm:block min-w-0">
                        <div className="font-serif text-lg text-white truncate">Passport</div>
                        <div className="overline truncate" style={{ fontSize: "8px" }}>{subtitle}</div>
                    </div>
                </Link>

                <PassportUserSearch compact className="max-w-none order-3 lg:order-none" />

                <div className="flex items-center justify-end gap-2 flex-wrap sm:flex-nowrap min-w-0">
                    <HeaderIconLink to="/discover" title="Discover" testId="passport-app-header-discover-link"><Globe size={16} /></HeaderIconLink>
                    <HeaderIconLink to="/traveldate" title="TravelDate" testId="passport-app-header-traveldate-link"><Heart size={15} /></HeaderIconLink>
                    <HeaderIconLink to="/concierge" title="Passport Concierge" testId="passport-app-header-concierge-link"><Compass size={15} /></HeaderIconLink>
                    <NotificationsBell />
                    <HeaderIconLink to="/messages" title="Passport messages" testId="passport-app-header-messages-link"><ChatCircle size={15} /></HeaderIconLink>
                    {user && (
                        <Link to={`/profile/${user.handle}`} title="Your profile" aria-label="Your profile" data-testid="passport-app-header-profile-link">
                            <img src={user.avatar_url || `https://api.dicebear.com/7.x/notionists/svg?seed=${user.handle}`} alt={user.name || user.handle} className="w-10 h-10 rounded-full object-cover" style={{ border: "1px solid rgba(212,175,55,0.4)" }} />
                        </Link>
                    )}
                    {user?.is_admin && <HeaderIconLink to="/owner" title="Owner Command Center" testId="passport-app-header-owner-link"><span style={{ color: "#D4AF37", fontSize: 15 }}>👑</span></HeaderIconLink>}
                    {user?.is_admin && <HeaderIconLink to="/admin/moderation" title="Moderation" testId="passport-app-header-admin-link"><span style={{ color: "#D4AF37" }}>🛡️</span></HeaderIconLink>}
                    <HeaderIconLink to="/settings" title="Settings" testId="passport-app-header-settings-link"><Gear size={15} /></HeaderIconLink>
                    <button type="button" onClick={signout} className="w-10 h-10 rounded-full glass grid place-items-center" title="Sign out" aria-label="Sign out" data-testid="passport-app-header-signout-button">
                        <SignOut size={14} />
                    </button>
                </div>
            </div>
        </header>
    );
}